<!-- *ngIf="!deviceDetector.isMobile() || (deviceDetector.isMobile() && !sidebarOpened)" *ngIf="!deviceDetector.isMobile()"-->
<header class="row header sticky-top m-0 shadow-sm" *ngIf="currentUser && router.url.indexOf('reports-crud') !== 1">
    <div class="col-md-4">
        <div class="row pl-3">
            <button type="button" [title]="sidebarState ? 'Cerrar menú' : 'Abrir menú'" class="btn mx-1 my-2" (click)="toggleSidebar()">
        <i
          [ngClass]="{
            'fa-bars': !sidebarState,
            'fa-chevron-left': sidebarState
          }"
          class="fa fa-lg"
          aria-hidden="true"
        ></i>
      </button>
            <div class="pt-1">
                <h4 class="mt-2">{{ currentPath }}</h4>
            </div>
        </div>
    </div>
    <div *ngIf="isFrom!==0" class="col-md-8 text-right mt-3" title="{{isFrom==2?'Cambiar de aplicación o compañia':'Cambiar de compañia'}}">
        <a (click)="OnclickNewChoice()" class="changeObject">{{labelForCompanyOrApp}}</a>


    </div>
</header>